import axios from "axios";
import API_MAP from "../../services/uri";
import errorHandler from "./errorHandler";

export const fetchVendorCategories = async () => {
	try {
		const response = await axios.get(`${API_MAP.viewCategories}`);
		return response.data.data;
	} catch (error) {
		console.log(
			"=====>Fetch categories response<====\n",
			error,
			"\n",
			error.response
		);
		return errorHandler(error);
	}
};

export const fetchVendorBookmarked = async () => {
	try {
		const response = await axios.get(
			`${API_MAP.viewAllVendors}?bookmarked=''`
		);
		return response.data.data;
	} catch (error) {
		console.log(
			"=====>Fetch bookmarked response<====\n",
			error,
			"\n",
			error.response
		);
		return errorHandler(error);
	}
};

export const fetchAllVendors = async (catId) => {
	try {
		const response = await axios.get(
			`${API_MAP.viewAllVendors}?categoryId=${catId}`
		);
		return response.data.data;
	} catch (error) {
		console.log(
			"=====>Fetch all vendors response<====\n",
			error,
			"\n",
			error.response
		);
		return errorHandler(error);
	}
};

export const fetchVendorDetails = async (data) => {
	try {
		const response = await axios.get(
			`${API_MAP.viewVendorDetails}/${data}`
		);
		return response.data.data;
	} catch (error) {
		console.log(
			"=====>Fetch all vendors response<====\n",
			error,
			"\n",
			error.response
		);
		return errorHandler(error);
	}
};

export const setVendorFavorite = async (credentials) => {
	try {
		const response = await axios.put(
			`${API_MAP.bookmarkVendor}`,
			credentials
		);
		return response.data;
	} catch (error) {
		console.log(
			"=====>Set fav vendors response<====\n",
			error,
			"\n",
			error.response
		);
		return errorHandler(error);
	}
};

export const rateVendor = async (credentials) => {
	try {
		const response = await axios.put(`${API_MAP.rateVendor}`, credentials);
		return response.data;
	} catch (error) {
		console.log(
			"=====>Rate vendors response<====\n",
			error,
			"\n",
			error.response
		);
		return errorHandler(error);
	}
};

export const createVendorStand = async (credentials) => {
	const response = await axios.post(`${API_MAP.createVendorStand}`, credentials);
	return response.data;
};

// export const deleteNote = async (credentials) => {
// 	const response = await axios.delete(
// 		`${BASE_URL}/notes/delete?noteId=${credentials}`
// 	);
// 	return response;
// };
